module.exports = __webpack_public_path__ + "static/media/tasklevel1_open.8e194cc6.png";